import { createSelector } from 'reselect';
import Immutable from 'seamless-immutable';
import { CurrentActiveAddressesSelector } from './customer.addresses.selectors';
import { add, clone, filter, pluck, prop, propEq, reduce } from 'ramda';
var EMPTY_OBJECT = {};
var RedeemGiftOrderSelector = function RedeemGiftOrderSelector(store) {
  return store.customercare.recoverableUiState.redeemGiftOrder;
};
export var GiftOrderPreviewAsMutableSelector = createSelector([RedeemGiftOrderSelector], function (redeemGiftOrder) {
  return redeemGiftOrder.giftOrderPreview.asMutable({
    deep: true
  });
});
export var GiftOrderSubmitSelector = createSelector([RedeemGiftOrderSelector], function (redeemGiftOrder) {
  return redeemGiftOrder.giftOrderSubmit;
});
export var IsFetchingPreviewGiftOrderSelector = createSelector([GiftOrderPreviewAsMutableSelector], function (giftOrderPreview) {
  return giftOrderPreview.isFetchingGiftOrderPreview;
});
export var IsSubmittingGiftOrderRedemptionSelector = createSelector([GiftOrderSubmitSelector], function (giftOrderSubmit) {
  return giftOrderSubmit.isSubmittingGiftOrderRedemption;
});
export var GiftOrderRedemptionCodeSelector = createSelector([RedeemGiftOrderSelector], function (redeemGiftOrder) {
  return redeemGiftOrder.redemptionCode;
});
export var GiftOrderRequiresPaymentInstrumentSelector = createSelector([GiftOrderPreviewAsMutableSelector], function (giftOrderPreview) {
  if (giftOrderPreview.subscriptions.length > 0) {
    return filter(propEq(true, 'paymentInstrumentRequired'), giftOrderPreview.subscriptions).length > 0;
  }
  return false;
});
export var SubscriptionRenewalChargeAndCurrencySelector = createSelector([GiftOrderPreviewAsMutableSelector], function (giftOrderPreview) {
  if (giftOrderPreview.subscriptions.length > 0) {
    var quoteSummary = {
      subtotal: 0,
      taxes: 0,
      discounts: 0,
      shipping: 0,
      total: 0
    };
    giftOrderPreview.subscriptions.forEach(function (subscription) {
      if (subscription.quoteSummary) {
        quoteSummary.subtotal = reduce(add, quoteSummary.subtotal, [subscription.quoteSummary.subtotal]);
        quoteSummary.taxes = reduce(add, quoteSummary.taxes, [subscription.quoteSummary.taxes]);
        quoteSummary.discounts = reduce(add, quoteSummary.discounts, [subscription.quoteSummary.discounts]);
        quoteSummary.shipping = reduce(add, quoteSummary.shipping, [subscription.quoteSummary.shipping]);
        quoteSummary.total = reduce(add, quoteSummary.total, [subscription.quoteSummary.total]);
      }
    });
    var currencyCode = giftOrderPreview.subscriptions[0].item.pricingPlan.currency;
    return {
      quoteSummary: quoteSummary,
      currencyCode: currencyCode
    };
  }
  return EMPTY_OBJECT;
});
export var GiftOrderSubscriptionQuotesAsMutableSelector = createSelector([RedeemGiftOrderSelector], function (redeemGiftOrder) {
  return redeemGiftOrder.giftOrderPreview.subscriptions && Immutable.asMutable(pluck('quoteSummary', filter(prop('quoteSummary'), redeemGiftOrder.giftOrderPreview.subscriptions)), {
    deep: true
  });
});
export var GiftOrderSelectedShippingAddressSelector = createSelector([RedeemGiftOrderSelector], function (redeemGiftOrder) {
  return redeemGiftOrder.selectedShippingAddress;
});
export var GiftOrderShipToNameSelector = createSelector([RedeemGiftOrderSelector], function (redeemGiftOrder) {
  return redeemGiftOrder.selectedShipToName;
});
export var ShippingAddressesAvailableForGiftOrder = createSelector([CurrentActiveAddressesSelector, GiftOrderPreviewAsMutableSelector], function (customerAddresses, giftOrderPreviewData) {
  var availableShippingAddresses = clone(customerAddresses);
  if (giftOrderPreviewData.shippingAddress) {
    availableShippingAddresses.unshift(giftOrderPreviewData.shippingAddress);
  }
  return availableShippingAddresses;
});
export var SelectedShippingMethodSelector = createSelector([RedeemGiftOrderSelector], function (redeemGiftOrder) {
  return redeemGiftOrder.selectedShippingMethod || null;
});